import { useState } from 'react';
import { MoreOutlined, ContainerOutlined, CopyOutlined, DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import IconButton from 'components/new-ui/base/icon-button/IconButton';
import PopoverButtonsGroup from 'components/new-ui/composed/popover-buttons-group/PopoverButtonsGroup';
import { StyledPopoverButton } from 'components/new-ui/composed/popover-buttons-group/styles';
import { GroupActionEvents } from '../../DeclarationColumns';
import { Space } from 'antd';

type Props = {
    sourceManifestId: string;
    actions?: GroupActionEvents;
    showActions: boolean;
    archived?: boolean;
};

const GroupActions = ({ sourceManifestId, actions, showActions, archived }: Props) => {
    const [open, setOpen] = useState(false);

    // Closes the popover when an action is triggered
    const withClose = (fn?: (record: string) => void) => (e: React.MouseEvent) => {
        e.stopPropagation();
        fn?.(sourceManifestId);
        setOpen(false);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <PopoverButtonsGroup
                open={open}
                onOpenChange={setOpen}
                buttonEl={
                    <IconButton
                        icon={<MoreOutlined />}
                        tooltipText="Actions"
                        disabled={!showActions}
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(true);
                        }}
                    />
                }
            >
                {actions?.onArchiveGroup && !archived && (
                    <StyledPopoverButton onClick={withClose(actions.onArchiveGroup)}>
                        <Space size={8}>
                            <ContainerOutlined />
                            Archive Group
                        </Space>
                    </StyledPopoverButton>
                )}

                {actions?.onUnarchiveGroup && archived && (
                    <StyledPopoverButton onClick={withClose(actions.onUnarchiveGroup)}>
                        <Space size={8}>
                            <InboxOutlined />
                            Unarchive Group
                        </Space>
                    </StyledPopoverButton>
                )}

                {actions?.onDeleteGroup && (
                    <StyledPopoverButton onClick={withClose(actions.onDeleteGroup)}>
                        <Space size={8}>
                            <DeleteOutlined />
                            Delete Group
                        </Space>
                    </StyledPopoverButton>
                )}
            </PopoverButtonsGroup>
        </div>
    );
};

export default GroupActions;
